<!-- Desktop kDS Header -->
   <app-header-promotion [custom_ticker]="custom_ticker"></app-header-promotion>
<div class="kds-icon">
    <app-header-sidebar-menu (sidebarState)="onSidebarStateChange($event)"></app-header-sidebar-menu>
</div>
<div class="header-wrapper d-none d-md-block normal-header pb-md-2 pb-lg-3" [class.show]="!isSticky">
    <div class="container-fluid ps-lg-5">
        <div class="row align-items-center">
            <div class="col-md-12 col-lg-2 text-center text-lg-start logo-tabs ps-lg-4 ps-xl-5">
                <app-header-logo *ngIf="showLogo"></app-header-logo>
            </div>
            <div class="col-md-12 col-lg-10">
                <div class="row">
                    <div class="col-9">
                        <div
                            class="d-flex align-items-center justify-content-center justify-content-md-start justify-content-lg-center">
                            <app-header-nav *ngIf="showFirstRowHeader"></app-header-nav>
                        </div>
                    </div>
                </div>
                <div class="row align-items-center justify-content-md-center justify-content-lg-start">
                    <div class="col-12 col-md-6 col-xl-8 pe-1 custom-left" [ngClass]="{ 'left-k-width': isWishlist}">
                        <app-header-search></app-header-search>
                    </div>
                    <div class="col-4 col-md-6 col-xl-4  ps-1 custom-right" [ngClass]="{ 'right-k-width': isWishlist}">
                        <div class="d-flex justify-content-md-around justify-content-lg-center wrap-app  align-items-center p-0">
                            <app-shop-by-vehicle *ngIf="isSearchByVehicleDisabled"></app-shop-by-vehicle>
                            <app-header-cart-section *ngIf="showSecondRowHeader"></app-header-cart-section>
                            <app-header-my-garage-section></app-header-my-garage-section>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<!-- Sticky Header -->
<div class="sticky-header d-none d-md-block header-content" [class.show]="isSticky">
    <div class="sticky-menu menu-icon" [ngClass]="{'sticky-active': isSticky}">
        <app-header-sidebar-menu (sidebarState)="onSidebarStateChange($event)"></app-header-sidebar-menu>
    </div>
    <div class="header-wrapper py-2">
        <div class="row px-3 align-items-center">
            <div class="col-md-12 col-lg-2 text-center text-lg-center logo-tabs  ps-5 d-flex justify-content-center"
                >
                <img [routerLink]="'/'" (click)="onButtonClick()" *ngIf="showLogo"
                    [src]="cdnImagePath + headerdata?.websiteHeader[firstObj + 2]?.desktop_logo" alt="Logo"
                    class="img-fluid d-none d-md-block desktop-img cursor-pointer" fetchpriority="high" width="138"
                    height="70" />
            </div>
            <div class="col-md-12 col-lg-10">
                <div class="row align-items-center">
                    <div class="col-12 mt-1 col-md-6 col-lg-8 col-xl-7 mt-3 pe-1 custom-left "
                        [ngClass]="{ 'left-k-width': isWishlist}">
                        <app-header-search></app-header-search>
                    </div>
                    <div class="col-4 col-md-6 col-lg-4 col-xl-5 mt-3 ps-1 custom-right "
                        [ngClass]="{ 'right-k-width': isWishlist}">
                        <div class="d-flex justify-content-md-around justify-content-lg-center wrap-app align-items-center p-0">
                            <app-shop-by-vehicle *ngIf="isSearchByVehicleDisabled"></app-shop-by-vehicle>
                            <app-header-cart-section *ngIf="showSecondRowHeader"
                                [showdowntooltip]="showdowntooltip"></app-header-cart-section>
                            <app-header-my-garage-section></app-header-my-garage-section>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<!-- Mobile Header -->
<div class="container d-md-none">
    <app-header-mobile-menu [headerSettings]="headerSettings" [custom_ticker]="custom_ticker"></app-header-mobile-menu>
</div>
<app-shopping-cart *ngIf="showCart"></app-shopping-cart>